import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BookingList } from "../../store/BookingSlice";
import { RootState } from "../../store/store";
import { BookingLists } from "../../interfaces/BookingList";
import { map } from "lodash";

export default function Bookings() {
    const dispatch = useDispatch<any>();
    useEffect(() => {
        // Dispatch the fetchHealthData action to fetch health data
        dispatch(BookingList());
      }, [dispatch]);
      const programsAll = useSelector((state: RootState) => {
        return state.booking.data || ([] as BookingLists[]);
      });
    return (
        <>
        <div>
            <h1 className="mb-4 text-3xl text-[#041B44] h-[40px]">My Bookings</h1>
        </div>
        <div className="bg-white rounded-lg h-[calc(100vh-226px)] overflow-y-scroll scrollbar-hide shadow-md  px-2 py-6">
        <div className="flex flex-wrap justify-start ">
            { Array.isArray(programsAll) ? programsAll.map((booking) =>{
                const formattedDate = new Intl.DateTimeFormat("en-US", {
                    weekday: "short",
                    year: "numeric",
                    month: "short",
                  }).format(new Date(booking?.program?.startDate));                 
                   return (           
                    <div className="w-full md:w-1/2 ">
                        <div className="flex flex-row  rounded-lg m-4 shadow-[0_2px_4px_4px_rgba(0,0,0,0.1)] mb-0">
                            <div className="basis-5/12 md:basis-4/12 ">
                            <a href={`booking/${booking.id}`}><img src={booking?.program?.icon} className="h-full object-cover w-auto rounded-l-lg"/></a>
                            </div>
                            <div className="basis-7/12 md:basis-8/12 p-2 md:px-6  md:pb-6">
                            <a href={`booking/${booking.id}`}>
                                <h3 className="text-lg md:text-xl font-semibold text-[#041B44] py-2">{booking?.program?.title}</h3>
                                <span className="text-[#31373a] ">Date</span>
                                <p className="text-[#263238] mb-6">{formattedDate}</p>
                                <a href={`booking/${booking.id}`} className="md:py-3 p-2 mb-2 md:px-5 uppercase font-semibold rounded-md bg-[#90A4AE] text-white hover:bg-white hover:text-[#78909C] border border-[#90A4AE]"><span className=" text-sm md:text-base ">View Details  </span>
                                    <svg width="24" height="15" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="pl-1 inline">
                                    <path d="M21 7.5H2" stroke="white" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M17.1914 2L22.715 7.49906L17.1914 13" stroke="white" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </a>
                                </a>
                            </div>
                        </div>
                    </div>            
                  )
                   }) : null }
        </div>
        </div>
        </>
    );
}